import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { digitsOnly, luhnValidateTenDigits } from './validation.utils';

export interface RegistrationNumberErrors {
  invalidFormat?: true;
  invalidLength?: true;
  invalidTypeDigit?: true;
  invalidCheckDigit?: true;
}

export const registrationNumberValidator: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  if (!control) {
    return null;
  }

  let value = (control.value ?? '').toString().trim();
  if (!value) {
    return null;
  }

  value = digitsOnly(value);

  if (value.length !== 10 && value.length !== 12) {
    return { invalidLength: true };
  }

  if (value.length === 12) {
    value = value.substring(2);
  }

  if (!/^\d{10}$/.test(value)) {
    return { invalidFormat: true };
  }

  // För organisationsnummer ska tredje siffran vara >= 2
  if (parseInt(value.charAt(2), 10) < 2) {
    return { invalidTypeDigit: true };
  }

  if (!luhnValidateTenDigits(value)) {
    return { invalidCheckDigit: true };
  }

  return null;
};